// extracted by mini-css-extract-plugin
export default {"accept":"UH2c4","decline":"l1A5D"};